export function SET_COUNTRIES(state, countries){
    state.countries = countries;
}

export function SET_LOADING_STATE(state, isLoading){
    state.isLoading = isLoading;
}

export function SET_REGION_FILTER(state, region){
    state.filter.region = region;
}

export function SET_ERROR(state, error){
    state.error = error;
}